module.exports = __webpack_public_path__ + "img/B8.3837325d.png";